import { useCallback, useMemo } from 'react';
import { Image } from '@components/common/Image';
import PageLoading from '@components/common/page-loading/page-loading';
import { UiKitButton } from '@components/common/ui-kit-button';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps, TpWizardValues } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import styles from './ReasonStep.module.scss';
const reasons = [{
  nextStep: WIZARD_STEPS.LOTS_OF_NEW,
  name: '1-I don’t use',
  image: 'sleeping-emoji.webp',
  text: "I don't use the app"
}, {
  nextStep: WIZARD_STEPS.KEEP_PREMIUM,
  name: '2-too expensive',
  image: 'money-emoji.webp',
  text: 'Too expensive'
}, {
  nextStep: WIZARD_STEPS.FEEDBACK,
  name: '3-not want I expect',
  image: 'monkey-emoji.webp',
  text: 'Not what I expected'
}, {
  nextStep: WIZARD_STEPS.FEEDBACK,
  name: '4-something else',
  image: 'woman-shrugging-emoji.webp',
  text: 'Something else (I will share my opinion)'
}, {
  nextStep: WIZARD_STEPS.FEEDBACK,
  name: '5-don’t like content',
  image: 'frowning-face-emoji.webp',
  text: 'I don’t like the content'
}, {
  nextStep: WIZARD_STEPS.LIFETIME_ACCESS,
  name: '6-auto-renewal',
  image: 'hi-hand-emoji.webp',
  text: 'I don’t want to pay for auto-renewal'
}];
export const ReasonStep = (props: TpWizardSteps) => {
  const {
    wizard,
    featureFlags
  } = props;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const filteredReasons = useMemo(() => {
    if (!featureFlags) return [];
    return featureFlags.lifetime ? reasons : reasons.slice(0, -1);
  }, [featureFlags]);
  const openedEventOptions = useMemo(() => ({
    ...defaultEventOptions,
    filteredReasons: filteredReasons.map(({
      name,
      nextStep,
      text
    }) => ({
      name,
      nextStep,
      text
    })),
    filteredReasonsCount: filteredReasons.length
  }), [defaultEventOptions, filteredReasons]);
  const buttonHandler = useCallback(({
    step,
    name
  }: {
    step: TpWizardValues;
    name: string;
  }) => {
    wizard.goToStep(step);
    trackUnsubscribeEvent('cancel_why_want_cancel_chosen', {
      reason: name
    });
  }, [wizard, trackUnsubscribeEvent]);
  const ItemReason = useCallback(({
    nextStep,
    name,
    image,
    text
  }: {
    nextStep: TpWizardValues;
    name: string;
    image: string;
    text: string;
  }) => <UiKitButton fullWidth color="secondary" className={styles.option} onClick={() => buttonHandler({
    step: nextStep,
    name
  })}>
        <div className={styles.imageWrapper}>
          <Image src={image} width={40} height={40} alt="" />
        </div>

        <span className={styles.buttonText}>{text}</span>
      </UiKitButton>, [buttonHandler]);
  return useMemo(() => featureFlags ? <Container className={styles.container} eventOnMounted="cancel_why_want_cancel_opened" eventOptions={openedEventOptions}>
          <Title className={styles.title}>
            Why do you want to <br /> unsubscribe?
          </Title>

          <div className={styles.grouped}>
            {filteredReasons.map(({
        nextStep,
        name,
        image,
        text
      }) => <ItemReason key={text} nextStep={nextStep} name={name} image={image} text={text} />)}
          </div>
          <UiKitButton onClick={() => buttonHandler({
      step: WIZARD_STEPS.HAPPY,
      name: '7-keep subscription'
    })}>
            Keep subscription
          </UiKitButton>
        </Container> : <PageLoading />, [ItemReason, buttonHandler, featureFlags, filteredReasons, openedEventOptions]);
};